var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5012C0.148078 5.01691 5.51461 -0.125529 12 0.00233361C18.4854 -0.125529 23.8519 5.01691 24 11.5012C23.8519 17.9855 18.4854 23.128 12 23.0001C10.4797 23.0032 8.97192 22.7262 7.55198 22.1832L4.76498 23.924C4.68553 23.9737 4.5937 24 4.5 24C4.22386 24 3.99998 23.7761 3.99998 23.5V20.0604C1.47862 17.9298 0.0169219 14.802 0 11.5012ZM19.2598 8.06163C19.4783 7.94258 19.751 8.00224 19.8998 8.20163C20.0494 8.39999 20.0307 8.67807 19.8558 8.85454L13.8558 14.854C13.6711 15.0387 13.3752 15.05 13.1769 14.88L9.93887 12.1052L4.73889 14.94C4.54478 15.0452 4.30464 15.0107 4.14803 14.8551C3.95214 14.6604 3.9512 14.3439 4.14587 14.148L10.1459 8.14862C10.3306 7.96386 10.6265 7.95256 10.8249 8.12261L14.0598 10.8964L19.2598 8.06163Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.a5335aab.svg";
export { ForwardRef as ReactComponent };